var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-medium article" },
      [
        _c("Heading", {
          attrs: {
            title: _vm.$t("about") + " " + _vm.capitalize(_vm.$t("us")),
            routeName: "vignette",
            alignment: "text-left",
          },
        }),
        _vm.locale == "ro"
          ? _c("div", { staticClass: "default-content reading" }, [
              _c(
                "p",
                [
                  _vm._v("Site-ul "),
                  _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                    _vm._v("E-rovinieta"),
                  ]),
                  _vm._v(
                    " este deținut de Uniunea Națională a Transportatorilor Rutieri din România (UNTRR)."
                  ),
                ],
                1
              ),
              _c("p", [
                _vm._v(
                  "UNTRR este o organizație profesională și patronală, neguvernamentală, independentă, apolitică, fondată în 1990 pe principii democratice, care promovează și apără interesele transportatorilor rutieri pe plan intern și internațional."
                ),
              ]),
              _c("p", [
                _c(
                  "strong",
                  [
                    _vm._v("Misiunea si viziunea "),
                    _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                      _vm._v("E-rovinieta"),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "p",
                [
                  _vm._v(" Platforma "),
                  _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                    _vm._v("E-rovinieta"),
                  ]),
                  _vm._v(
                    " urmărește să fie liderul în furnizarea serviciului online de cumpărare a rovinietei pentru utilizatorii persoane fizice și juridice. Misiunea noastră este de a oferi clienților cea mai bună experiență de cumpărare a rovinietei și de a-i ajuta în respectarea legislației privind regimul de taxare al drumurilor din România. "
                  ),
                ],
                1
              ),
              _c(
                "p",
                [
                  _vm._v(" UNTRR și platforma "),
                  _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                    _vm._v("E-rovinieta"),
                  ]),
                  _vm._v(
                    " sunt parteneri de încredere pentru posesorii de autovehicule din România și ne propunem să le oferim servicii cu valoare adăugată pentru a le economisi timp și pentru a-i ajuta în activitatea zilnică. "
                  ),
                ],
                1
              ),
              _c("p", [
                _c(
                  "b",
                  [
                    _vm._v("Valorile "),
                    _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                      _vm._v("E-rovinieta"),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._m(0),
            ])
          : _c("div", { staticClass: "default-content reading" }, [
              _c(
                "p",
                [
                  _vm._v("The website "),
                  _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                    _vm._v("E-rovinieta"),
                  ]),
                  _vm._v(
                    " is owned by the National Union of Road Hauliers from Romania (UNTRR)."
                  ),
                ],
                1
              ),
              _c("p", [
                _vm._v(
                  "UNTRR is an organisation - professional and employers, non-governmental, independent, apolitical - founded in 1990 on democratic principles, promoting and defending the interests of road transport domestically and internationally."
                ),
              ]),
              _vm._m(1),
              _c(
                "p",
                [
                  _vm._v(" The platform "),
                  _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                    _vm._v("E-rovinieta"),
                  ]),
                  _vm._v(
                    " aims to be the leader in providing the online service for buying vignettes for individuals and legal entities. Our mission is to offer customers the best shopping experience and to help them comply with the Romanian legislation about tolling."
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(" UNTRR and the platform "),
                  _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                    _vm._v("E-rovinieta"),
                  ]),
                  _vm._v(
                    " are reliable partners for vehicle owners and we aim to offer value-added services to save time and help them in their daily activities. "
                  ),
                ],
                1
              ),
              _vm._m(2),
              _vm._m(3),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("Excelență operațională")]),
      _c("li", [_vm._v("Inovație")]),
      _c("li", [_vm._v("Responsabilitate")]),
      _c("li", [_vm._v("Colaborare")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("Mission and vision statements")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("The values of E-rovinieta.ro")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("Operational excellence")]),
      _c("li", [_vm._v("Innovation")]),
      _c("li", [_vm._v("Responsibility")]),
      _c("li", [_vm._v("Collaboration")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }